import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import style from './style.module.scss';

const TRANSLATION_KEY = 'TranscriptText.string';

export function Text(props) {
  const {
    t,
    //i18l
  } = useTranslation();

  const text = t(TRANSLATION_KEY);

  return <span className={style.transcript_title}>{text}</span>;
}

Text.propTypes = {};
